import type { ReactNode } from "react";
import { IconTrendArrow } from "../../icons/IconTrendArrow/IconTrendArrow";
import "./TrendIndicator.scss";

export type TrendIndicatorProps = {
  trend: "higher" | "lower" | "equal";
  difference: ReactNode;
};
export const TrendIndicator = ({ trend, difference }: TrendIndicatorProps) => {
  if (trend === "equal") return null;

  const isHigher = trend === "higher";
  const direction = isHigher ? "up" : "down";

  return (
    <span className={`trend-indicator trend-indicator--${direction}`}>
      <IconTrendArrow direction={direction} color={isHigher ? "green" : "red"} />
      <span className="trend-indicator__value">{difference}</span>
    </span>
  );
};
